var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.581 19.581h-3.405V14.25c0-1.272-.023-2.91-1.77-2.91-1.774 0-2.046 1.386-2.046 2.817v5.425H8.955V8.615h3.269v1.498h.046a3.587 3.587 0 0 1 3.225-1.77c3.451 0 4.088 2.27 4.088 5.222l-.002 6.016zM5.113 7.116A1.985 1.985 0 0 1 3.137 5.14c0-1.084.892-1.976 1.976-1.976s1.975.892 1.976 1.975a1.985 1.985 0 0 1-1.976 1.977zM6.816 19.58h-3.41V8.615h3.41V19.58zM21.279.001H1.696A1.685 1.685 0 0 0 0 1.659v19.664c.01.92.776 1.668 1.696 1.659h19.583a1.689 1.689 0 0 0 1.702-1.659V1.657A1.688 1.688 0 0 0 21.279 0v.002z","fill":"currentColor"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 23 24","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
